export default __webpack_public_path__ + "static/media/bb-00002.02ac0ede.png";